import { fromJS } from 'immutable';
import { concat, map } from 'lodash';
import {
  ADD_PATIENT_WAITLIST,
  ADD_PATIENT_WAITLIST_ERROR,
  ADD_PATIENT_WAITLIST_SUCCESS,
  CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS,
  ITEMS_PER_PAGE,
  LOAD_ACCOUNTS,
  LOAD_ACCOUNTS_ERROR,
  LOAD_ACCOUNTS_SUCCESS,
  LOAD_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_SUCCESS,
  LOAD_NOTIFICATIONS_ERROR,
  LOAD_DATA_SUCCESS,
  LOAD_DATA,
} from './constants';

const initialState = fromJS({
  accounts: false,
  error: false,
  loading: false,
  loadingNotifications: false,
  modalOpened: false,
  notifications: false,
  notificationsPage: 1,
  organization: false,
  data: false,
});

const reducer = (state = initialState, action) => {
  /**
   * Header rules:

   * Simple actions: For example, non promise actions
   * Request actions: Promise or not, this actions will fire a response action
   * Success response actions: Success action, fired by the request action can
   *                           contains database information for example.
   * Error response actions: Error action fired when something goes wrong with
   *                         the request action
  */
  switch (action.type) {
    // Simple actions
    // Request actions
    case ADD_PATIENT_WAITLIST:
      return state.set('loading', true).set('error', false);
    case LOAD_NOTIFICATIONS:
      return state
        .set('error', false)
        .set('loadingNotifications', true)
        .set('notificationsPage', typeof action.page === 'number' ? action.page : 1)
        .set('notifications', action.page > 0 ? state.get('notifications') : []);
    case LOAD_ACCOUNTS:
      return state.set('accounts', false).set('organization', false);
    case LOAD_DATA:
      return state.set('loading', true).set('error', false);
    // Success response actions
    case ADD_PATIENT_WAITLIST_SUCCESS:
      return state.set('loading', false);
    case CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS: {
      const notifications = map(state.get('notifications'), (notification) => ({
        ...notification,
        read: true,
      }));

      return state.set('notifications', notifications);
    }
    case LOAD_NOTIFICATIONS_SUCCESS: {
      let page = state.get('notificationsPage');
      const notifications = state.get('notifications') ? state.get('notifications') : [];
      let newNotifications = page === 0 ? notifications : action.notifications;

      if (page > 1) {
        newNotifications = concat([], notifications, newNotifications);
      }

      if (action.notifications.length === 0 || action.notifications.length < ITEMS_PER_PAGE) {
        page = 0;
      }

      return state
        .set('loadingNotifications', false)
        .set('notificationsPage', page)
        .set('notifications', newNotifications);
    }
    case LOAD_ACCOUNTS_SUCCESS:
      return state.set('accounts', action.accounts).set('organization', action.organization);
    case LOAD_DATA_SUCCESS:
      return state.set('loading', false).set('data', action.data);
    // Error response actions
    case ADD_PATIENT_WAITLIST_ERROR:
      return state.set('error', action.error).set('loading', false);
    case LOAD_NOTIFICATIONS_ERROR:
      return state.set('error', action.error).set('loadingNotifications', false);
    case LOAD_ACCOUNTS_ERROR:
      return state.set('error', action.error);
    default:
      return state;
  }
};

export default reducer;
